import React from 'react';
import Breadcrumbs, {
  BreadcrumbItem,
  breadcrumbLabel as label,
} from '@/components/Breadcrumbs';
import { StudySiteData } from '@/types/study';

function buildBreadcrumbs(site: StudySiteData): BreadcrumbItem[] {
  const currentItem: BreadcrumbItem = {
    label: label('Site', site.display_id || site.site_name),
    path: null,
  };

  if (!site.study) {
    return [currentItem];
  }

  const studyItem: BreadcrumbItem = {
    label: label('Study', site.study.display_id || site.study.protocol_number),
    path: site.study.can_view ? site.study.show_path : null,
  };

  return [studyItem, currentItem];
}

interface SiteBreadcrumbsProps {
  site: StudySiteData;
}

const SiteBreadcrumbs: React.FC<SiteBreadcrumbsProps> = ({ site }) => (
  <Breadcrumbs items={buildBreadcrumbs(site)} />
);

export default SiteBreadcrumbs;
